<dx-load-panel
    shadingColor="{{option.shadingColor? option.shadingColor : 'rgba(0,0,0,0.4)' }}"
    [visible]="option.visible"
    [showIndicator]="true"
    [showPane]="option.showPane==false? false : true"
    [shading]="true"
    [message]="option.message"
    [closeOnOutsideClick]="option.closeOnOutsideClick"
    [position]="option.ofPosition? { of: option.ofPosition}: '' "
    >
</dx-load-panel>